import { render, staticRenderFns } from "./ManagementContactsContact.vue?vue&type=template&id=5e79f2df"
import script from "./ManagementContactsContact.vue?vue&type=script&lang=js"
export * from "./ManagementContactsContact.vue?vue&type=script&lang=js"
import style0 from "./ManagementContactsContact.vue?vue&type=style&index=0&id=5e79f2df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports